<template>
  <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
    <b-navbar-brand :to="{ name: 'Home' }">
      <img src="@/assets/images/logo.png" alt="logo" height="34" />
    </b-navbar-brand>
    <b-navbar-nav v-if="$store.getters['users/isAuthenticated']">
      <b-nav-item-dropdown text="Catégories">
        <b-dropdown-item
          :to="{
            name: 'AddCategories'
          }"
          >Créer une catégorie</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'CategoriesQuickSearch'
          }"
          >Recherche rapide</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'Categories'
          }"
          >Toutes les catégories</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <b-nav-item-dropdown text="Attributs">
        <b-dropdown-item :to="{ name: 'AddAttribute' }"
          >Créer un attribut</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'AttributesQuickSearch'
          }"
          >Recherche rapide</b-dropdown-item
        >
        <b-dropdown-item :to="{ name: 'Attributes' }"
          >Tous les attributs</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <b-nav-item-dropdown text="Imports en masse">
        <b-dropdown-item
          :to="{
            name: 'ImportCsv',
            params: { importName: 'attributes' }
          }"
          >Attributs</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'ImportCsv',
            params: { importName: 'categories' }
          }"
          >Catégories</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'ImportCsv',
            params: { importName: 'values' }
          }"
          >Valeurs</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'ImportCsv',
            params: { importName: 'mappings' }
          }"
          >Mappings</b-dropdown-item
        >
      </b-nav-item-dropdown>
      <b-nav-item-dropdown text="Export en masse">
        <b-dropdown-item
          :to="{
            name: 'ExportCsv',
            params: { exportName: 'values' }
          }"
          >Value</b-dropdown-item
        >
        <b-dropdown-item
          :to="{
            name: 'ExportCsv',
            params: { exportName: 'categoriesMappings' }
          }"
          >Mappings</b-dropdown-item
        >
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  name: "gwzNav"
};
</script>

<style scoped></style>
